module.exports = __webpack_public_path__ + "static/media/hand-write-text.d8439908.png";